<p>{{ "MODAL_CONTENTS.ABANDON_NOTICE.PARAGRAPH" | translate }}</p>
